import { Pipe, PipeTransform } from '@angular/core';
import { OrderSource } from '@shared/types/order-source';

@Pipe({
  name: 'orderSource',
  standalone: false,
})
export class OrderSourcePipe implements PipeTransform {
  transform(value: OrderSource): string | undefined {
    switch (value) {
      case 'intranet':
        return 'Intranet';
      case 'partnerzone':
        return 'PartnerZone';
      case 'api':
        return 'API';
      case 'online_store':
        return 'Online Store';
      case 'global_e_store':
        return 'Global E-Store';
      case 'auto_renewal_system':
        return 'Auto Renewal System';
      case 'system':
        return 'System';
      default:
        return undefined;
    }
  }
}
